import React from "react";
import {connect} from "react-redux";
import store from "../../../store";
import {getGroups, login} from "../../../providers/users";
import {NavLink, withRouter} from "react-router-dom";
import LocaleSwitch from "../../common/LocaleSwitch";
import LoginErrorMessages from "./LoginErrorMessages";
import Logo from "../../common/Logo";
import browser from 'browser-detect';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {setSfaFlow, setUserLoggedInStatus} from "../../../actions/userActions";
import Wave from "../../common/Wave";
import Loader from "../../common/Loader";
import {getLatestTermsAndConditions} from "../../../providers/termsAndConditions";
import {checkIfTermsAreNotAccepted, getProfileActionsShared} from "./AuthUtils";

import localforage from "localforage";

const Translate = require('react-redux-i18n').Translate;

const I18n = require('react-redux-i18n').I18n

const stateMap = (store) => {
    return {
        i18n: store.i18n,
        userReducer: store.userReducer,
        merchantReducer: store.merchantReducer
    };
};

class Login extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            emailPlaceholder: I18n.t('pages.login.emailPlaceholder'),
            passwordPlaceholder: I18n.t('pages.login.passwordPlaceholder'),
            wrongCreds: false,
            roleNotMerchant: false,
            nonConfirmedAccount: false,
            disabledAccount: false,
            username: "",
            password: "",
            successfulPassReset: false,
            loginButtonLoaderEnabled: false,
            showPassword: false,
            notAllowedIp: false,
            phoneNotFound: false,
            accountNotFound: false,
        };

        this.login = this.login.bind(this)
        this.checkIfPasswordHasExpired = this.checkIfPasswordHasExpired.bind(this)
        this.checkIfSfaRequired = this.checkIfSfaRequired.bind(this)
        this.checkIfTooManyLoginAttempts = this.checkIfTooManyLoginAttempts.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.capsLockDetect = this.capsLockDetect.bind(this)
        this.removeCapsWarning = this.removeCapsWarning.bind(this)
        this.focusedInPassword = this.focusedInPassword.bind(this)
        this.invalidateAllErrors = this.invalidateAllErrors.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.getProfileActions = this.getProfileActions.bind(this)
        this.toggleShowPassword = this.toggleShowPassword.bind(this)
        this.impersonatorLogin = this.impersonatorLogin.bind(this)

    }

    componentDidMount() {
        // Check if impersonation is already active on mount
        if (this.props.userReducer.impersonator !== null) {
            this.impersonatorLogin();
            return;
        }

        if (this.props.userReducer.userLoggedIn) {
            this.props.history.push("/overview")
        }
        if (this.props.userReducer.inSfaFlow) {
            this.props.history.push("/sfa")
        }
        document.addEventListener("keydown", this.capsLockDetect, false);
        browser();
        this.setState({
            successfulPassReset: this.props.location.state && this.props.location.state.successfulPassReset ?
                this.props.location.state.successfulPassReset : false
        })
        this.props.history.push({hash: this.props.i18n.locale})
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.capsLockDetect, false);
    }


    focusedInPassword(event) {
        this.setState({
            focusedInPassword: true
        })
    }


    capsLockDetect(e) {
        if (e.keyCode === 20 && this.state.capsLockEnabled !== null) {
            this.setState({
                capsLockEnabled: !this.state.capsLockEnabled
            })
        }
    }

    removeCapsWarning() {
        this.setState({
            focusedInPassword: false
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // Handle i18n locale changes
        if (prevProps.i18n !== this.props.i18n) {
            this.setState({
                emailPlaceholder: I18n.t('pages.login.emailPlaceholder'),
                passwordPlaceholder: I18n.t('pages.login.passwordPlaceholder')
            })
            this.props.history.push({hash: this.props.i18n.locale})
        }
    }

    invalidateAllErrors() {
        this.setState({
            wrongCreds: false,
            nonConfirmedAccount: false,
            disabledAccount: false,
            roleNotMerchant: false,
            notAllowedIp: false,
            phoneNotFound: false,
            accountNotFound: false
        })
    }


    login() {
        const username = this.state.username
        const password = this.state.password
        const currentUrl = window.location.origin
        store.dispatch(getLatestTermsAndConditions(this.props.i18n.locale))
        this.setState({
            loginButtonLoaderEnabled: true
        })
        store.dispatch(login(username, password, currentUrl)).then(
            (response) => {
                const data = response && response.value && response.value.data;

                // 1) 428 error cases (sfa required, password expired, terms not accepted)
                if (data && data.payload && data.payload.errorMessage) {
                    this.setState({loginButtonLoaderEnabled: false});
                    const errorMessage = data.payload.errorMessage;
                    if (this.checkIfSfaRequired(errorMessage)) {
                        // Mark that we're entering the SFA flow so SfaForm guard allows it
                        store.dispatch(setUserLoggedInStatus(false));
                        store.dispatch(setSfaFlow(true));
                        this.props.history.push('/sfa');
                    } else if (this.checkIfPasswordHasExpired(errorMessage)) {
                        this.props.history.push({pathname: '/expired/password'});
                    } else if (checkIfTermsAreNotAccepted(errorMessage)) {
                        this.getProfileActions(true);
                    } else {
                        store.dispatch(setUserLoggedInStatus(false));
                        this.invalidateAllErrors();
                        this.setState({wrongCreds: true});
                    }
                    return;
                }

                // 2) Normal success flow
                getProfileActionsShared(false, {
                    setState: (s) => this.setState(s),
                    invalidateAllErrors: this.invalidateAllErrors,
                    props: this.props
                });
            },
            (error) => {
                this.setState({
                    loginButtonLoaderEnabled: false
                });

                const resp = error && error.response;
                const errData = resp && resp.data;

                if (this.checkIfPhoneNotFound(resp)) {
                    store.dispatch(setUserLoggedInStatus(false));
                    this.invalidateAllErrors();
                    this.setState({
                        phoneNotFound: true
                    });
                } else if (this.checkIfAccountNotFound(resp)) {
                    store.dispatch(setUserLoggedInStatus(false));
                    this.invalidateAllErrors();
                    this.setState({
                        accountNotFound: true
                    });
                } else if (this.checkIfIpNotAllowed(resp)) {
                    store.dispatch(setUserLoggedInStatus(false));
                    this.invalidateAllErrors();
                    this.setState({
                        notAllowedIp: true
                    });
                } else if (this.checkUserDisabled(resp)) {
                    store.dispatch(setUserLoggedInStatus(false));
                    this.invalidateAllErrors();
                    this.setState({
                        disabledAccount: true
                    });
                } else if (resp && this.checkIfTooManyLoginAttempts(errData && errData.description)) {
                    store.dispatch(setUserLoggedInStatus(false));
                    localforage.setItem('userResetPwPhone', true);
                    this.invalidateAllErrors();
                    this.setState({
                        wrongCreds: true
                    });
                } else {
                    store.dispatch(setUserLoggedInStatus(false));
                    this.invalidateAllErrors();
                    this.setState({
                        wrongCreds: true
                    });
                }
            }
        ).then(() => {
          store.dispatch(getGroups())
        });
    }

    getProfileActions(showTermsAndConditions) {
        getProfileActionsShared(showTermsAndConditions, {
            setState: (s) => this.setState(s),
            invalidateAllErrors: this.invalidateAllErrors,
            props: this.props
        });
    }

    checkIfSfaRequired(errorResponse) {
        return errorResponse === 'SECOND_FACTOR_AUTH_REQUIRED'
    }


    checkIfPasswordHasExpired(errorResponse) {
        return errorResponse === 'PASSWORD_EXPIRED'
    }

    checkIfTooManyLoginAttempts(errorResponse) {
        return errorResponse === 'TOO_MANY_LOGIN_ATTEMPTS'
    }

    checkIfPhoneNotFound(errorResponse) {
        return errorResponse.status && errorResponse.status === 404 && errorResponse.data && errorResponse.data.errors
            && errorResponse.data.errors.length > 0 && errorResponse.data.errors[0] === 'PHONE_NOT_FOUND'
    }

    checkIfAccountNotFound(errorResponse) {
        return errorResponse.status && errorResponse.status === 404 && errorResponse.data && errorResponse.data.errors
            && errorResponse.data.errors.length > 0 && errorResponse.data.errors[0] === 'ACCOUNT_NOT_FOUND'
    }

    checkIfIpNotAllowed(errorResponse) {
        return errorResponse.status && errorResponse.status === 403 && errorResponse.data && errorResponse.data.errors
            && errorResponse.data.errors.length > 0 && errorResponse.data.errors[0] === 'NOT_ALLOWED_IP'
    }

    checkUserDisabled(errorResponse) {
        return errorResponse.status && errorResponse.status === 403 && errorResponse.data && errorResponse.data.errors
            && errorResponse.data.errors.length > 0 && errorResponse.data.errors[0] === 'USER_IS_DISABLED'
    }


    handleChange(event) {
        this.setState({
            [event.target.id]: event.target.value
        })
    }

    toggleShowPassword() {
        this.setState(prevState => ({
            showPassword: !prevState.showPassword
        }));
    }

    handleCloseModal() {
        this.setState({
            successfulPassReset: false
        });
        this.props.history.replace({
            pathname: '/login',
            state: {}
        })
    }

    impersonatorLogin() {
        if (this.props.userReducer.impersonator !== null) {
            store.dispatch(getLatestTermsAndConditions(this.props.i18n.locale))
            store.dispatch(getGroups())
            this.setState({
                loginButtonLoaderEnabled: true
            });
            this.getProfileActions()
        }
    }

    render() {
        if (this.props.userReducer.redirectToCardlink) {
            this.props.history.push("/cardlink")
        }
        let currentYear = new Date().getFullYear();
        const loggedIn = this.props.userReducer.userLoggedIn;

        const loginInProgress = this.props.userReducer?.loginProcedure?.fetching || this.state.loginButtonLoaderEnabled || this.props.userReducer?.getAssociationsResponse?.fetching;

        return (
            loggedIn === false || loginInProgress ?
                <div className="login-area__wrapper">
                    <Modal show={this.state.roleNotMerchant}
                           backdrop="static"
                           backdropClassName="login-area__backdrop"
                           dialogClassName="intro-dialog intro-dialog__login-screen">
                        <Modal.Body>
                            <article className="article__login-screen">
                                <Translate value="pages.login.nonMerchantModalMsgA"/>
                                <br/>
                                <a href="/mrchnt">mrchnt.cardlink.gr</a>
                                <br/>
                                <Translate value="pages.login.nonMerchantModalMsgB"/>
                            </article>
                        </Modal.Body>
                    </Modal>
                    <Modal show={this.state.successfulPassReset} onHide={this.handleCloseModal}
                           dialogClassName="reset-area-step1__custom-modal">
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <Translate className="generic-modal-title" value="pages.reset.successfulPassChange"/>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="generic-success-modal-msg">
                                <span className="icon-success"/>
                                <Translate className="text-success" value="pages.reset.youcanNowLogin"/>
                            </div>
                        </Modal.Body>
                    </Modal>
                    <main className="login-area">
                        <div className="login-area__top">
                            <LocaleSwitch type={"login-area"}></LocaleSwitch>
                        </div>
                        <div className="login-area__content">
                            <div className="login-area__left">
                                <p className="login-area__sub-header">
                                    <Translate value="pages.login.tool"/>
                                </p>
                                <h3 className="login-area__text login-area__text_intro">
                                    <Translate value="pages.login.everyDay"/>
                                </h3>
                                <ul className="login-area__text login-area__text_list">
                                    <li>
                                        <Translate value="pages.login.listItem1"/>
                                    </li>
                                    <li>
                                        <Translate value="pages.login.listItem2"/>
                                    </li>
                                    <li>
                                        <Translate value="pages.login.listItem3"/>
                                    </li>
                                </ul>
                                <div className="login-area__copyright">{'©Cardlink ' + currentYear}</div>
                            </div>
                            <div className="login-area__login-with-forgot">
                                <div className="login-area__login-box">
                                    <Logo isMain={false} isHeader={false} imgClassName="login" isNotLink={true}/>
                                    <form onSubmit={(e) => {
                                        e.preventDefault();
                                        this.login();
                                    }}>
                                        <Translate value="pages.login.email"/>
                                        <input type="email" required={true}
                                               onChange={this.handleChange}
                                               placeholder={this.state.emailPlaceholder} size="40"
                                               id="username" name="username" value={this.state.username}/>
                                        <Translate value="pages.login.password"/>
                                        <div className="password-container">
                                            <div className="login-area__login-box__password">
                                                <input type={this.state.showPassword ? "text" : "password"}
                                                       onChange={this.handleChange}
                                                       onBlur={this.removeCapsWarning}
                                                       onFocus={this.focusedInPassword}
                                                       placeholder={this.state.passwordPlaceholder} size="40"
                                                       required={true}
                                                       id="password"
                                                       name="password"
                                                       value={this.state.password}/>
                                            </div>
                                            <Button onClick={this.toggleShowPassword}
                                                    className={"icon-password-eye" + (this.state.showPassword ? " icon-show-password-eye" : " icon-hide-password-eye")}>
                                            </Button>
                                        </div>
                                        <div className="login-area__login-box__wrong-creds">
                                            <LoginErrorMessages info={this.state}/>
                                        </div>

                                        <div className="login-area__login-button-area">
                                            <button type="submit" className="login-area__login-button"
                                                    disabled={loginInProgress}>
                                                {loginInProgress ?
                                                    <Loader bouncing={false} color={'white'} message=''
                                                            style={{marginTop: 0}} bounceClass='smaller-bounces'/> :
                                                    <Translate value="pages.login.buttonText"/>
                                                }
                                            </button>
                                        </div>
                                        <div className="login-area__forgot-password">
                                            <NavLink to={"/reset"} activeClassName="_active">
                                                <Translate value="pages.login.forgotPassword"/>
                                            </NavLink>
                                        </div>
                                    </form>
                                </div>
                                <div className="login-area__register-area">
                                    <Translate value="pages.login.newUser"/>
                                    <NavLink to={"/register"} activeClassName="_active">
                                        <button type="button" className="login-area__register-button">
                                            <Translate value="pages.login.registerIn5Steps"/>
                                        </button>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                        <Wave/>
                    </main>
                </div> : null
        )
    }
}

export default withRouter(connect(stateMap)(Login));
